import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface PropsType {
  data: any;
  onClose: () => void;
}

const ViewTagModal: React.FC<PropsType> = ({ data, onClose }) => {
  return (
    <div
      className={`w-screen fixed top-0  left-0 h-screen z-[999] bg-black/60 flex items-center justify-center`}
    >
      <div className="w-[95%] max-h-[95%] h-fit max-w-[700px] bg-white rounded-lg relative">
        <div
          id="close-btn"
          onClick={() => onClose && onClose()}
          className="absolute cursor-pointer w-[17px] h-[17px] lg:w-[1.2vw] lg:h-[1.2vw] border-2 border-white top-[-10px] font-size-13px right-[-10px] rounded-full text-white bg-red-500 flex items-center justify-center"
        >
          <FontAwesomeIcon icon={faXmark} />
        </div>
        <div className="w-full overflow-y-auto">
          {data && (
            <h1 className="font-Poppins-SemiBold p-4 font-size-20px text-center border-b w-full border-gray-400">
              Product Tag
            </h1>
          )}
          {data && (
            <div className="w-full flex flex-col gap-3 py-5 px-6">
              <div>
                <h1 className="font-Poppins-SemiBold font-size-20px mb-1">
                  Banner Image
                </h1>
                <img
                  src={data?.banner}
                  alt="Banner Image"
                  className="rounded-lg w-full h-[20vh] object-cover border border-gray-300"
                />
              </div>
              <div>
                <h1 className="font-Poppins-SemiBold font-size-20px mb-1">
                  Tag Name
                </h1>
                <p className="font-Poppins-Regular font-size-16px">
                  {data?.name}
                </p>
              </div>
              <div>
                <h1 className="font-Poppins-SemiBold font-size-20px mb-1">
                  Description
                </h1>
                <p className="font-Poppins-Regular font-size-16px break-words">
                  {data?.description}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewTagModal;
